/// <reference types="webpack-env" />

import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import PageWrapper from 'containers/pageWrapper/pageWrapper';
import Msal from 'containers/authorization/Msal';
import { RoutingConfiguration } from './views';
import './styles/excluded.css';
import 'styles/sticky-header.css';
import 'styles/custom.css';
import moment from 'moment';
import { RumInit } from '@maersk-global/telemetry-web-sdk';
import { CONFIG } from 'configs/index';

moment.locale('en-gb');

const render = (Component: React.ComponentClass) =>
    
    ReactDOM.render(
        <Provider store={store}>
            <Msal>
                <BrowserRouter>
                    <PageWrapper>
                        <Component />
                    </PageWrapper>
                </BrowserRouter>
            </Msal>
        </Provider>,
        document.getElementById('root') as HTMLElement,
    );

render(RoutingConfiguration);

// registerServiceWorker();

if (module.hot) {
    module.hot.accept('./views', () => {
        const NextRoutingConfiguration = require('./views').RoutingConfiguration;
        render(NextRoutingConfiguration);
    });
}

RumInit({
    app: {
      name: CONFIG.MOP_APP_NAME,
      version: '1.0.0',
      environment: process.env.NODE_ENV
    },
    ignoreUrls: [`http://localhost:${process.env.PORT}/`, '.*datadoghq.*'],
    apiKey: CONFIG.MOP_API_KEY, // This is api key for dev
    debug: true, // Shows the captured in console
    traceLog: true, // Sends Traces to Loki ( For easy querying of traces)
    performanceInstrument: { ignoreEvents: ['msal.*'] },
  });
